<template>
<div>

<tti-header class="shadow-sm"></tti-header>

<div class="min-h-screen bg-gray-100 py-12">
  <div class="mx-auto px-4 flex justify-end max-w-screen-xl">
    <TailwindButton
      size="xlarge"
      @click="$router.push({ name: 'FindATutor' })"
    >
      Post a Job
    </TailwindButton>
  </div>

  <div class="mt-8 grid gap-4 mx-auto px-4 max-w-screen-xl sm:grid-cols-2 lg:grid-cols-3">

    <div
      v-for="job of jobs"
      :key="job.id"
      class="flex flex-col p-4 bg-white shadow rounded-lg md:p-6"
    >
      <div class="flex justify-between items-center">
        <div class="text-lg text-gray-800 font-medium">
          {{ job.Title }}
        </div>
        <div v-if="dayjs().diff(job.AddedWhen, 'week') < 2" class="inline-flex items-center rounded-full bg-blue-100 px-2 py-1 text-xs font-medium text-blue-700 uppercase">
          New
        </div>
      </div>
      
      <div class="flex-grow mt-1 text-sm leading-relaxed text-gray-700">
        {{ job.Body.substring(0, 200) }}
        <span v-if="job.Body.length > 200">… <button type="button" @click="enquire(job)" class="text-blue-600 underline" style="text-underline-offset: 2px">Read more</button></span>
      </div>

      <button 
        type="button"
        @click="enquire(job)"
        class="mt-4 inline-flex justify-center items-center w-full px-1 py-2 group border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:w-30"
      >
        <span>Enquire</span>
        <ChevronRightIcon class="w-0 h-5 transition-all group-hover:w-5" />
      </button>
    </div>

  </div>
</div>

<component
  :is="modalType"
  :key="selectedJob?.Id"
  :job="selectedJob"
  :showModal="showModal"
  @closeModal="showModal = false"
/>

<tti-footer></tti-footer>

</div>
</template>
<script>

import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import { ChevronRightIcon } from '@vue-hero-icons/solid'

import TtiHeader from '@/prototype/HeaderNew'
import TtiFooter from '@/prototype/Footer'
import JobBoardServices from '../../services/JobBoardServices'
import UserServices from '../../services/UserServices'
import EnquireModal from './Modals/Enquire.vue'
import AccountRequiredModal from './Modals/AccountRequired.vue'
import SubscriptionRequiredModal from './Modals/SubscriptionRequired.vue'
import TailwindButton from '../TailwindButton.vue'

dayjs.extend(relativeTime)


export default {
  components: {
    TtiHeader,
    TtiFooter,
    EnquireModal,
    AccountRequiredModal,
    SubscriptionRequiredModal,
    ChevronRightIcon,
    TailwindButton,
  },
  data() {
    return {
      dayjs,
      jobs: [],
      selectedJob: null,
      showModal: false,
    }
  },
  computed: {
    user() { return this.$store.getters.user },
    modalType() {
      if (this.user?.IsSubscriber) return EnquireModal
      if (this.$store.getters.isLoggedIn) return SubscriptionRequiredModal
      else return AccountRequiredModal
    }
  },
  methods: {
    enquire(job) {
      this.selectedJob = job
      this.showModal = true
    }
  },
  async mounted() {
    const { data } = await new JobBoardServices().getPublicJobs()
    this.jobs = data

    try {
      this.$store.dispatch('refreshUser');
    } catch { /* Not logged in */ }
  }
}

</script>
